const sliders = () => {
	if ($('.slider')[0]) {
		// Double image into img slider
		var clipPath = $('.clippedImage')
		var tl = new TimelineMax({ repeat: -1, repeatDelay: 0, yoyo: true })
		tl.to(clipPath, 0.5, {
			webkitClipPath: 'inset(0 35% 0 40%)',
			clipPath: 'inset(0 35% 0 40%)',
		})
			.to(clipPath, 2.5, {
				webkitClipPath: 'inset(0 5% 0 60%)',
				clipPath: 'inset(0 5% 0 60%)',
				ease: SlowMo.ease.config(0.7, 0.7, false),
			})
			.to(clipPath, 3, {
				webkitClipPath: 'inset(0 60% 0 10%)',
				clipPath: 'inset(0 60% 0 10%)',
				ease: SlowMo.ease.config(0.7, 0.7, false),
			})
			.to(clipPath, 3.5, {
				webkitClipPath: 'inset(0 0% 0 65%)',
				clipPath: 'inset(0 0% 0 65%)',
				ease: SlowMo.ease.config(0.7, 0.7, false),
			})
			.to(clipPath, 4, {
				webkitClipPath: 'inset(0 30% 0 60%)',
				clipPath: 'inset(0 30% 0 60%)',
				ease: SlowMo.ease.config(0.7, 0.7, false),
			})
		//double slider
		$('.double-slider .slider-img').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 8000,
			pauseOnHover: true,
			fade: true,
			asNavFor: '.slider-text',
		})
		$('.double-slider .slider-text').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			asNavFor: '.slider-img',
			focusOnSelect: true,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 8000,
			pauseOnHover: true,
			fade: true,
			prevArrow: $('.sliderPrev'),
			nextArrow: $('.sliderNext'),
		})
	}
}
export { sliders }
